import { TranslationDetailScreen } from "@/features/staff/localization";

export default function LocalizationKeyPage() {
  return <TranslationDetailScreen />;
}
